<template>
  <table class="tb-col"
         v-if="isInit">
    <colgroup>
      <col style="width:8%;" />
      <col style="width:auto;" />
      <col style="width:auto;" />
      <col style="width:16%" />
      <col style="width:20%;" />
    </colgroup>
    <thead>
    <tr>
      <th>번호</th>
      <th>시설명</th>
      <th>시설유형</th>
      <th>초대일자</th>
      <th class="last">수락 / 거절</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(nvtn, index) in fcltyNvtns"
        :key="nvtn.fcltyMberNvtnDt">
      <td>{{ index+1 }}</td>
      <td class="__left">{{ nvtn.fcltyNm }}</td>
      <td>{{ nvtn.fcltyTynm }} {{ nvtn.fcltyDpTynm? ' / ' + nvtn.fcltyDpTynm : '' }}</td>
      <td>{{ $cmmn.date.getYmdFormat(nvtn.fcltyMberNvtnDt.substring(0, 8), '-') }}</td>
      <td class="last">
        <btn :txt="'수락'"
             :size="'ssmall'"
             :color="'purple'"
             @click="btnAcpt_click(nvtn)"/>
        <btn :txt="'거절'"
             :size="'ssmall'"
             :color="'white'"
             @click="btnRfsl_click(nvtn)"/>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script setup>
import {onMounted, ref, defineEmits} from "vue";
import {getStore, getUtils} from "@/utils/import";

const {$axios, $confirm, $alert, $cmmn} = getUtils();
const {$loading, $mber} = getStore();

const emits = defineEmits(['close']);

const fcltyNvtns = ref([]);
const getFcltyNvtnsByMberSn = async () => {
  const {data} = await $axios.get('/api/fclty/mber-nvtns/by-mber-sn', {params: {mberSn: $mber.mberSn}});
  fcltyNvtns.value = data;

  if (data.length == 0) emits('close');
}

const btnAcpt_click = async ({fcltySn, tgtMberSn, fcltyMberNvtnDt, nvtnFcltyMberSecd}) => {
  try {
    $loading.on();

    const isConfirm = await $confirm('초대에 수락하시겠습니까?');
    if (!isConfirm) return false;

    await acptNvtn({fcltySn, tgtMberSn, fcltyMberNvtnDt, nvtnFcltyMberSecd});
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const acptNvtn = async ({fcltySn, tgtMberSn, fcltyMberNvtnDt, nvtnFcltyMberSecd}) => {
  const {data} = await $axios.post('/api/fclty/mber-nvtn-acpt', {fcltySn, tgtMberSn, fcltyMberNvtnDt, nvtnFcltyMberSecd});

  if (data == 0) {
    await $alert('오류가 발생하였습니다. 다시 시도해주세요.');
    return false;
  }

  await getFcltyNvtnsByMberSn();
}

const btnRfsl_click = async ({fcltySn, tgtMberSn, fcltyMberNvtnDt}) => {
  try {
    $loading.on();

    const isConfirm = await $confirm('초대에 거절하시겠습니까?');
    if (!isConfirm) return false;

    await rfslNvtn({fcltySn, tgtMberSn, fcltyMberNvtnDt});
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const rfslNvtn = async ({fcltySn, tgtMberSn, fcltyMberNvtnDt}) => {
  const {data} = await $axios.post('/api/fclty/mber-nvtn-rfsl', {fcltySn, tgtMberSn, fcltyMberNvtnDt});

  if (data == 0) {
    await $alert('오류가 발생하였습니다. 다시 시도해주세요.');
    return false;
  }

  await getFcltyNvtnsByMberSn();
}

const isInit = ref(false);
onMounted(async () => {
  try {
    $loading.on();

    await getFcltyNvtnsByMberSn();
    isInit.value = true;
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})

</script>

<style scoped>

</style>
